function origine(vm) {
  return vm.$store.state.origine.recherche;
}

function personnePhysique(origine, idPersonne, idContact) {
  return {
    name: `recherche/${origine}/personne-physique/detail`,
    params: {
      id: idPersonne,
      contact: idContact,
    },
  };
}

function personneMorale(origine, idPersonne) {
  return {
    name: `recherche/${origine}/personne-morale/detail`,
    params: {
      id: idPersonne,
    },
  };
}

function instance(origine, idInstance) {
  return {
    name: `recherche/${origine}/instance/detail`,
    params: {
      id: idInstance,
    },
  };
}
/* permet de recuperer le contexte de la recherche (simple ou avancee) dans le store pour former un nom de lien qui respecte le fil d'arianne
 */

const mixin = {
  methods: {
    $liens() {
      return {
        personnePhysique: (idPersonne, idContact) =>
          personnePhysique(origine(this), idPersonne, idContact),
        personneMorale: idPersonne => personneMorale(origine(this), idPersonne),
        instance: idInstance => instance(origine(this), idInstance),
      };
    },
  },
};

export default {
  install(Vue) {
    Vue.mixin(mixin);
  },
};
